import React, { Component } from "react";
import {
  InputGroup,
  Input,
  Col,
  Row,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Button,
  Table
} from 'reactstrap';
import BlockUi from 'react-block-ui';
import { reduxForm } from 'redux-form'
import { connect } from 'react-redux';
import Messages from '../../notifications/Messages'
import Collapsible from 'react-collapsible';
import Errors from '../../notifications/Errors'
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { currentDate } from '../../lib/common'
import * as khachhangAction from './actions'
import DisplayRecordText from "../controls/_DisplayRecordText"
import Moment from "react-moment";
import Pagination from "react-js-pagination";

class Khachhang247 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 1,
      tuNgay: currentDate().startOf('month'),
      denNgay: currentDate(),
      listImport: [],
      listExport: [],
      keyword: '',
      pageImport: 1,
      pageExport: 1,
      perPageImport: 20,
      perPageExport: 20,
      totalRecordImport: 0,
      totalRecordExport: 0
    };
  }
  getParam = (name) => {
    const queryParamsString = this.props.location.search.substring(1),
      searchParams = new URLSearchParams(queryParamsString);
    return searchParams.get(name);
  }
  handleTabChange = (activeTab) => {
    this.setState({ activeTab: activeTab })
  }
  handleDateChange = (name, e, value) => {
    switch (name) {
      case "tuNgay":
        this.setState({ tuNgay: e });
        break;
      case "denNgay":
        this.setState({ denNgay: e });
        break;
      default:
        break;
    }
  }
  handleSearchChange = (name, e, value) => {
    switch (name) {
      case "keyword":
        this.setState({ keyword: e.target.value });
        break;
      default:
        break;
    }
  }
  fetchList(page) {
    if (this.state.khachHangId && this.state.khachHangId > 0) {
      const { khachhangListDonRequest } = this.props
      var requestData = {
        tuNgay: this.state.tuNgay ? this.state.tuNgay.unix() : '',
        denNgay: this.state.denNgay ? this.state.denNgay.endOf('days').unix() : '',
        keyword: this.state.keyword,
        loaiHd: this.state.activeTab,
        khachHangId: this.state.khachHangId,
        page: page || (this.state.activeTab == 1 ? this.state.pageExport : this.state.pageImport),
        per_page: (this.state.activeTab == 1 ? this.state.perPageExport : this.state.perPageImport)
      }
      return khachhangListDonRequest(requestData, (res) => {
        if (this.state.activeTab == 1) {
          this.setState({ listExport: res.data.records, totalRecordExport: res.data.totalRecord })
        } else {
          this.setState({ listImport: res.data.records, totalRecordImport: res.data.totalRecord })
        }
      })
    }
  }
  search = () => {
    if (this.props.khachhang247.isRequesting) {
      return false;
    }
    return this.setState({ page: 1 }, () => {
      this.fetchList(1);
    });
  }
  keyPress = (e) => {
    if (e.keyCode == 13) {
      this.search()
    }
  }
  BackToListkhachhang = (item, e) => {
    this.props.history.push('/khachhang');
  }
  khachHangDetail = () => {
    this.props.history.push('/khachhang-edit?kid=' + (this.state.khachHangId));
  }
  onChangeItem = (itemPerPage) => {
    if (this.state.activeTab == 1) {
      this.setState({ perPageExport: itemPerPage }, () => {
        this.search();
      });
    } else {
      this.setState({ perPageImport: itemPerPage }, () => {
        this.search();
      });
    }
  }
  handlePageChangeImport = (pageNumber) => {
    let pageImport = parseInt(pageNumber || 1)
    return this.setState({ pageImport }, () => {
      this.fetchList(pageImport)
    });
  }
  handlePageChangeExport = (pageNumber) => {
    let pageExport = parseInt(pageNumber || 1)
    return this.setState({ pageExport }, () => {
      this.fetchList(pageExport)
    });
  }
  componentDidMount() {
    this.setState({ khachHangId: this.getParam("kh") })
  }
  render() {
    const {
      activeTab,
      listImport,
      listExport
    } = this.state;

    const {
      handleSubmit,
      khachhang247: {
        isRequesting,
        errors,
        messages
      },
    } = this.props
    return (
      <div className="animated fadeIn">
        <BlockUi tag="div" blocking={isRequesting} >
          <div>
            <Collapsible trigger="Tìm kiếm" overflowWhenOpen="inherit" open={true}>
              <Row className="report-control">
                <Col sm="2" xs="6" className="mb-2 pr-0 half-left">
                  <InputGroup size="md">
                    <span className="add_date_exs_span">Từ:</span>
                    <DatePicker
                      dateFormat="DD/MM/YYYY"
                      name="tuNgay" placeholder="Từ ngày"
                      selected={this.state.tuNgay}
                      onChange={this.handleDateChange.bind(this, "tuNgay")}
                      required className={"form-control add_date_exs_input"} />
                  </InputGroup>
                </Col>
                <Col sm="2" xs="6" className="mb-2 pr-0 half-right">
                  <InputGroup size="md">
                    <span className="add_date_exs_span">Đến:</span>
                    <DatePicker
                      dateFormat="DD/MM/YYYY"
                      name="denNgay" placeholder="đến ngày"
                      selected={this.state.denNgay}
                      onChange={this.handleDateChange.bind(this, "denNgay")}
                      required className={"form-control add_date_exs_input"} />
                  </InputGroup>
                </Col>
                <Col sm="6" className="mb-2">
                  <InputGroup size="md">
                    <Input name="keyword"
                      placeholder="Tìm tên hoặc mã thuốc"
                      value={this.state.keyword}
                      onChange={this.handleSearchChange.bind(this, "keyword")}
                      onKeyDown={e => this.keyPress(e)} />
                  </InputGroup>
                </Col>
                <Col sm="2" className="mb-2 text-right">
                  <div className="w-100">
                    <Button size="md" color="success" className="mr-1" onClick={handleSubmit(this.search)}><i className="fa fa-search"></i> Thống kê</Button>&nbsp;
                  </div>
                </Col>
              </Row>
            </Collapsible>
          </div>
          <div className="mb-2 mt-2">
            <Nav tabs className="w-100">
              <NavItem>
                <NavLink className={activeTab == 1 ? 'active text-primary' : ''} onClick={() => this.handleTabChange(1)}>
                  Đơn bán
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink className={activeTab == 2 ? 'active text-primary' : ''} onClick={() => this.handleTabChange(2)}>
                  Đơn nhập
                </NavLink>
              </NavItem>
            </Nav>
            <TabContent activeTab={activeTab}>
              <TabPane tabId="1" className={activeTab == 1 ? 'active' : ''}>
                <div className="mt-2 bg-white">
                  <div className="w-100">
                    <DisplayRecordText
                      itemsCountPerPage={this.state.perPageImport}
                      onChangeItem={this.onChangeItem}
                    />
                    <Table hover responsive className="table-outline mb-0 d-sm-table table-sm">
                      <thead className="thead-default">
                        <tr>
                          <th scope="col" width="50" className="text-center">#</th>
                          <th scope="col" className="text-left">Mã thuốc</th>
                          <th scope="col" className="text-left">Tên thuốc</th>
                          <th scope="col" className="text-left">Đơn vị tính</th>
                          <th scope="col" className="text-left">Số lô</th>
                          <th scope="col" className="text-left">Số đăng ký</th>
                          <th scope="col" className="text-left">Hạn dùng</th>
                          <th scope="col" className="text-right">Số lượng</th>
                        </tr>
                      </thead>
                      <tbody>
                        {listExport && !!listExport.length && (
                          listExport.map((res, idx) => (
                            <tr key={idx + 1}>
                              <td className="text-center">{idx + 1}</td>
                              <td className="text-left">{res.Sku}</td>
                              <td className="text-left">{res.TenThuoc}</td>
                              <td className="text-left">{res.Dvt}</td>
                              <td className="text-left">{res.SoLo}</td>
                              <td className="text-left">{res.SoDangKy}</td>
                              <td className="text-left">{res.HanDung && <Moment tz={'UTC'} format="DD/MM/YYYY">{`${res.HanDung}`}</Moment>}</td>
                              <td className="text-right text-danger font-weight-bold">{parseFloat(res.SoLuong || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}</td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </Table>
                    {this.state.totalRecordExport > this.state.perPageExport && (
                      <Pagination
                        activePage={this.state.pageExport}
                        itemsCountPerPage={this.state.perPageExport}
                        totalItemsCount={this.state.totalRecordExport}
                        pageRangeDisplayed={5}
                        onChange={this.handlePageChangeExport}
                      />
                    )}
                  </div>
                  <div className="clearfix"></div>
                </div>
                <div className="clearfix"></div>
              </TabPane>
              <TabPane tabId="2" className={activeTab == 2 ? 'active' : ''}>
                <div className="mt-2 bg-white">
                  <div className="w-100">
                    <DisplayRecordText
                      itemsCountPerPage={this.state.perPageImport}
                      onChangeItem={this.onChangeItem}
                    />
                    <Table hover responsive className="table-outline mb-0 d-sm-table table-sm">
                      <thead className="thead-default">
                        <tr>
                          <th scope="col" width="50" className="text-center">#</th>
                          <th scope="col" className="text-left">Mã thuốc</th>
                          <th scope="col" className="text-left">Tên thuốc</th>
                          <th scope="col" className="text-left">Đơn vị tính</th>
                          <th scope="col" className="text-left">Số lô</th>
                          <th scope="col" className="text-left">Số đăng ký</th>
                          <th scope="col" className="text-left">Hạn dùng</th>
                          <th scope="col" className="text-right">Số lượng</th>
                        </tr>
                      </thead>
                      <tbody>
                        {listImport && !!listImport.length && (
                          listImport.map((res, idx) => (
                            <tr key={idx + 1}>
                              <td className="text-center">{idx + 1}</td>
                              <td className="text-left">{res.Sku}</td>
                              <td className="text-left">{res.Ten}</td>
                              <td className="text-left">{res.Dvt}</td>
                              <td className="text-left">{res.SoLo}</td>
                              <td className="text-left">{res.SoDangKy}</td>
                              <td className="text-left">{res.HanDung && <Moment tz={'UTC'} format="DD/MM/YYYY">{`${res.HanDung}`}</Moment>}</td>
                              <td className="text-right text-danger font-weight-bold">{parseFloat(res.SoLuong || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}</td>
                            </tr>
                          ))
                        )}
                      </tbody>

                    </Table>
                    {this.state.totalRecordImport > this.state.perPageImport && (
                      <Pagination
                        activePage={this.state.pageImport}
                        itemsCountPerPage={this.state.perPageImport}
                        totalItemsCount={this.state.totalRecordImport}
                        pageRangeDisplayed={5}
                        onChange={this.handlePageChangeImport}
                      />
                    )}
                  </div>
                  <div className="clearfix"></div>
                </div>
                <div className="clearfix"></div>
              </TabPane>
            </TabContent>
          </div>
        </BlockUi>
        <Row>
          <Col md="12">
            {!isRequesting && !!errors.length && (
              <Errors errors={errors} />
            )}
            {!isRequesting && !!messages.length && (
              <Messages messages={messages} />
            )}
          </Col>
        </Row>
      </div>
    )
  }
}
const mapStateToProps = state => ({
  khachhang247: state.khachhang247,
})
const connected = connect(mapStateToProps, {
  khachhangListDonRequest: khachhangAction.khachhangListDonRequest
})(Khachhang247)

const formed = reduxForm({
  form: 'khachhang247',
})(connected)

export default formed;


// WEBPACK FOOTER //
// ./src/views/KhachHang/Khachhang247.js